import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { CaseNote } from "./case-note";

export class CaseNoteFile extends Resource {
    public override type = 'caseNoteFiles';
    @prop()
    @required()
    public caseNoteId!: string;

    public caseNote!: CaseNote;
   
    @prop()
    public fileId!: string;

    public file!: File;
}